// resources/js/components/modal.js

export function registerModal(Alpine) {
  Alpine.data('genericModal', () => ({
    modalId:  null,
    isOpen:   false,
    loading:  false,
    url:      '',
    method:   'POST',
    form:     {},
    open(detail) {
        console.log('[genericModal.open] called | this.modalId:', this.modalId, '| detail.id:', detail.id)
        console.log('[genericModal.open] called | this.modalId:', this.modalId, '| detail.id:', detail.id)

    this.modalId = detail.id
      this.url    = detail.url
      this.method = detail.method ?? 'POST'
      this.form   = { ...(detail.data ?? {}) }
      this.isOpen = true
    console.log('[genericModal.open] isOpen set TRUE for:', this.modalId)

  this.$nextTick(() => {
    window.dispatchEvent(new CustomEvent('modal:open', {
      detail: { id: this.modalId }  // ← tambah id
    }))
  })
    },

    close() {
      if (this.loading) return
      this.isOpen = false
  window.dispatchEvent(new CustomEvent('modal:close', {
    detail: { id: this.modalId }  // ← id selalu ikut, apapun alasannya tutup
  }))
      // Also dispatch on the element for local listeners
      this.$el?.dispatchEvent(new Event('modal:close'))
    },

    // ── Called by @select-change.window inside the modal ─────────
    // Writes the chosen value back into form using the modelKey
    handleSelectChange({ key, value }) {
      if (key) this.form[key] = value
    },

    async submit() {
    if (!this.$refs.form.checkValidity()) {
        this.$refs.form.reportValidity();
        return;
    }
    this.loading = true;
    // Beri kesempatan komponen lain handle submit-nya sendiri
    const customEvent = new CustomEvent('modal:before-submit', {
        detail: { id: this.modalId },
        cancelable: true
    });
    const notCancelled = window.dispatchEvent(customEvent);

    if (!notCancelled) return; // komponen lain sudah handle


      try {
//        const csrf       = document.querySelector('meta[name="_csrf"]')?.content
//        const csrfHeader = document.querySelector('meta[name="_csrf_header"]')?.content ?? 'X-CSRF-TOKEN'
//        const res  = await fetch(this.url, {
//          method:  this.method,
//          headers: {
//            'Content-Type':  'application/json',
//            'Accept':        'application/json',
//            ...(csrf ? { [csrfHeader]: csrf } : {}),
//          },
//          body: JSON.stringify(this.form),
//        })
        const res = await apiFetch(this.url, {   // ← pakai apiFetch global
            method: this.method,
            body: JSON.stringify(this.form),
        });

        if (res.ok) {
        this.loading= false;
//          this.$dispatch('form-success', { url: this.url, id: this.modalId })
            window.dispatchEvent(new CustomEvent('form-success', {
              detail: { id: this.modalId }
            }))

          // Gunakan ini jika di html
//          $store.notify.success('Berhasil', 'Disimpan.')
            Alpine.store('notify').success('Berhasil', 'Disimpan.')
          this.close()
        } else {
          const msg = await res.text().catch(() => 'Unknown error')
          Alpine.store('notify').error('Failed', `Simpan gagal: ${msg}`)
        }
      } catch (err) {
        console.error('[modal] submit error:', err)
        Alpine.store('notify').error('Failed', `${err}`)
      } finally {
        this.loading = false
      }
    },
  }))
}